<template>
  <div>
    <!-- <js-mask></js-mask> -->

    <js-header></js-header>

    <js-navigation-header></js-navigation-header>

    <js-navigation-sp-mask></js-navigation-sp-mask>

    <div class="l-wrapper" id="js-wrapper">
      <breadcrumb v-bind:breadcrumbs="breadcrumbs"></breadcrumb>

      <js-hero></js-hero>

      <router-view />

      <js-footer></js-footer>
    </div>
  </div>
</template>

<script>
import jQuery from "jquery";

// import JsMask from '@/components/organisms/JsMask.vue'
import JsHeader from "./components/organisms/JsHeader.vue";
import JsNavigationHeader from "@/components/organisms/JsNavigationHeader.vue";
import JsNavigationSpMask from "@/components/organisms/JsNavigationSpMask.vue";
import Breadcrumb from "@/components/organisms/Breadcrumb.vue";
import JsHero from "@/components/organisms/JsHero.vue";
import JsFooter from "@/components/organisms/JsFooter.vue";

export default {
  name: "IrTop",
  metaInfo: {
    title: "IR情報 | 株式会社 旅工房",
    titleTemplate: null,
    htmlAttrs: {
      lang: "ja",
    },
    meta: [
      { charset: "utf-8" },
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      {
        name: "description",
        content:
          "株式会社旅工房のIR情報ページです。旅工房の特徴について、取り扱い国数やツアー数、取扱高の推移、顧客満足度など数字で分かりやすくご紹介しています。また、レジャー事業部と法人事業部に分かれ、専門的に事業を展開する旅工房についてもご紹介しています。",
      },
      {
        name: "keywords",
        content: "旅工房,会社概要,海外旅行,旅行会社",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      { name: "robots", content: "noodp" },
      { name: "applemobile-we-app-title", content: "株式会社 旅工房" },

      { property: "og:locale", content: "ja_JP" },
      {
        property: "og:title",
        content: "IR情報 | 株式会社 旅工房",
      },
      {
        property: "og:site_name",
        content: "海外旅行・海外ツアーなら「旅工房」",
      },
      { property: "og:type", content: "article" },
      { property: "og:url", content: location.href },
      {
        property: "og:image",
        content: "http://www.tabikobo.com/images/fb_ogp.png",
      },
      {
        property: "og:description",
        content:
          "海外航空券を検索。最安値の格安海外航空券の検索・予約がスピーディーに可能、オンラインで決済完了。海外格安航空券の予約なら「旅工房」。",
      },
      { property: "twitter:card", content: "summary" },
      { property: "twitter:title", content: "IR情報 | 株式会社 旅工房" },
      {
        property: "twitter:description",
        content:
          "株式会社旅工房のIR情報ページです。旅工房の特徴について、取り扱い国数やツアー数、取扱高の推移、顧客満足度など数字で分かりやすくご紹介しています。また、レジャー事業部と法人事業部に分かれ、専門的に事業を展開する旅工房についてもご紹介しています。",
      },
    ],
    script: [
      {
        type: "application/ld+json",
        innerHTML: JSON.stringify(
          [
            {
              "@context": "http://schema.org",
              "@type": "Organization",
              url: location.href,
              logo: "http://www.tabikobo.com/images/fb_ogp.png",
            },
            {
              "@context": "http://schema.org",
              "@type": "WebSite",
              name: "IR情報 | 株式会社 旅工房",
              alternateName:
                "株式会社旅工房のIR情報ページです。旅工房の特徴について、取り扱い国数やツアー数、取扱高の推移、顧客満足度など数字で分かりやすくご紹介しています。また、レジャー事業部と法人事業部に分かれ、専門的に事業を展開する旅工房についてもご紹介しています。",
              url: location.href,
            },
          ],
          null,
          2
        ),
      },
    ],
  },
  components: {
    // JsMask,
    JsHeader,
    JsNavigationHeader,
    JsNavigationSpMask,
    Breadcrumb,
    JsHero,
    JsFooter,
  },
  data() {
    return {
      classes: [],
    };
  },
  computed: {
    breadcrumbs() {
      // パンくずの定義がvue-routerのmetaフィールドでされているか調べる
      if (this.$route.matched.some((obj) => obj.meta.breadcrumbs)) {
        // 存在するなら使う
        return this.$route.meta.breadcrumbs;
      }
      // ない場合は、HOMEとだけ表示させる
      return false;
    },
    ua() {
      return navigator.userAgent.toLowerCase();
    },
    ver() {
      return navigator.appVersion.toLowerCase();
    },
    isMSIE() {
      return this.ua.indexOf("msie") > -1 && this.ua.indexOf("opera") == -1;
    },
    isIE6() {
      return this.isMSIE && this.ver.indexOf("msie 6.") > -1;
    },
    isIE7() {
      return this.isMSIE && this.ver.indexOf("msie 7.") > -1;
    },
    isIE8() {
      return this.isMSIE && this.ver.indexOf("msie 8.") > -1;
    },
    isIE9() {
      return this.isMSIE && this.ver.indexOf("msie 9.") > -1;
    },
    isIE10() {
      return this.isMSIE && this.indexOf("msie 10.") > -1;
    },
    isIE11() {
      return this.ua.indexOf("trident/7") > -1;
    },
    isIE() {
      return this.isMSIE || this.isIE11;
    },
    isEdge() {
      return this.ua.indexOf("edge") > -1;
    },
    isChrome() {
      return this.ua.indexOf("chrome") > -1 && this.ua.indexOf("edge") == -1;
    },
    isFirefox() {
      return this.ua.indexOf("firefox") > -1;
    },
    isSafari() {
      return this.ua.indexOf("safari") > -1 && this.ua.indexOf("chrome") == -1;
    },
    isOpera() {
      return this.ua.indexOf("opera") > -1;
    },
    isAndroid444() {
      return this.ua.indexOf("android 4.4.4") > -1;
    },
    isAndroid442() {
      return this.ua.indexOf("android 4.4.2") > -1;
    },
    isIos8() {
      return this.ver.indexOf("iphone os 8") > -1;
    },
  },
  mounted() {
    if (this.isIE) {
      this.classes.push("browser-ie");
    }
    if (this.isIE6) {
      this.classes.push("browser-ie6");
    }
    if (this.isIE7) {
      this.classes.push("browser-ie7");
    }
    if (this.isIE8) {
      this.classes.push("browser-ie8");
    }
    if (this.isIE9) {
      this.classes.push("browser-ie9");
    }
    if (this.isIE10) {
      this.classes.push("browser-ie10");
    }
    if (this.isIE11) {
      this.classes.push("browser-ie11");
    }
    if (this.isEdge) {
      this.classes.push("browser-edge");
    }
    if (this.isChrome) {
      this.classes.push("browser-chrome");
    }
    if (this.isFirefox) {
      this.classes.push("browser-firefox");
    }
    if (this.isSafari) {
      this.classes.push("browser-safari");
    }
    if (this.isOpera) {
      this.classes.push("browser-opera");
    }
    if (this.isAndroid444) {
      this.classes.push("browser-android444");
    }
    if (this.isAndroid442) {
      this.classes.push("browser-android442");
    }

    if (this.isIos8) {
      this.classes.push("os-ios8");
    }

    jQuery("body").addClass(this.classes.join(" "));
  },
};
</script>
